import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ReactGA from "react-ga4";

import { useBusinessNameContext } from "../../context/BusinessName";
import { ShowESim } from "../../API/Sim";
import Title from "../../new-components/title/Title";
import HeaderInner from "../../Components/HeaderInner";
import CustomBusinessServiceLoader from "../../Components/Loaders/CustomBusinessServiceLoader";
import { Zoom } from "react-reveal";
import Overllay from "../../assets/new_imgs/Rectangle 1072.png";

function E_SimCompanies() {
  const { businessName, setBusinessName } = useBusinessNameContext();
  const navigate = useNavigate();
  const location = useLocation();
  const rawPath = location.pathname;
  const { t, i18n } = useTranslation();

  const room_uuid = rawPath.split("/")[1];
  const lang = localStorage.getItem("lang");
  const new_design = localStorage.getItem("new_design");
  const theme = new_design === "true";

  const { data, isLoading, error } = ShowESim(room_uuid, lang);

  const [simData, setSimData] = useState(null);

  useEffect(() => {
    if (!isLoading && data?.data?.status === false) {
      navigate(`/${room_uuid}/qr-scan`);
    } else if (!isLoading && data?.data?.status === true) {
      setSimData(data.data.data);
    }
  }, [isLoading, data, navigate, room_uuid]);

  useEffect(() => {
    if (!isLoading && data?.data?.data?.sim_companies.length === 1) {
      const singleCompany = data.data.data.sim_companies[0];
      navigate(`/${room_uuid}/sims/${singleCompany.uuid}`, { replace: true });
    }
  }, [isLoading, , data, navigate, room_uuid]);

  if (error) return <></>;
  return (
    <div className={`${theme && "food"} ${lang === "AR" && "arabic"}`}>
      {theme ? (
        <Title title={simData?.header_title || ""} />
      ) : (
        <HeaderInner headerName={simData?.header_title || ""} />
      )}

      {isLoading ? (
        <CustomBusinessServiceLoader
          businessName={"Companies"}
          loader={"spa"}
        />
      ) : (
        <main className="box_food image_services home-main bg-white back-white ">
          {simData?.sim_companies?.map((company) => {
            return theme ? (
              <div key={company.uuid}>
                <Link to={`/${room_uuid}/sims/${company.uuid}`}>
                  <img src={company?.logo} alt="" className="booking_img" />
                  <img src={Overllay} alt="" className="overlay" />
                  <div className="text_food">
                    <h5 className="">{company.name}</h5>
                  </div>
                </Link>
              </div>
            ) : (
              <div id={company.name} key={company.uuid}>
                <Zoom>
                  <div
                    className="con-img-container v3"
                    onClick={() =>
                      navigate(`/${room_uuid}/sims/${company.uuid}`)
                    }
                  >
                    <div className="con-img">
                      <img src={company.logo} alt="" />
                      <p></p>
                    </div>
                  </div>
                  <div className="con-text-container">
                    <p>{company.name}</p>
                    <hr className="mb-0 dark" />
                  </div>
                </Zoom>
              </div>
            );
          })}
        </main>
      )}
      {/* <HeaderInner headerName={text} />
      <main className="home-main bg-white back-white pad-top-0 pb-4">
        {isLoading ? (
          <CustomBusinessServiceLoader
            businessName={businessName}
            loader="concierge"
          />
        ) : (
          concierges?.map((x, idx) => {
            return (
              <div
                className="con-img-container"
                id={x.text}
                key={idx}
                onClick={() => {
                  navigate(`/${room_uuid}/${x.slug}`);
                  ReactGA.event({
                    category: "Select concierge",
                    action: "Click",
                    value: `concierge: ${x.slug}`,
                  });
                }}
              >
                <div className="con-img">
                  <img src={x.image} alt="" />
                  <p>{t(`${x.name}`)}</p>
                </div>
              </div>
            );
          })
        )}
      </main> */}
    </div>
  );
}
export default E_SimCompanies;
